export default __webpack_public_path__ + "static/media/gallery_03.e269c052.jpg";